<template>
  <section>
    <va-modal
      :value="showModal"
      ref="createOrUpdateUser"
      :okText="$t('references.inputs.save')"
      :cancelText="$t('modal.cancel')"
      :noOutsideDismiss="true"
      @ok="submitForm"
      @cancel="onCancel"
      >
        <div slot="header" class="modal-title">
          <span >{{ isUpdate ? $t('users.edit_user') : $t('users.create_user') }}</span>
        </div>

        <form class="evollu-form">

          <!-- Edit User Name -->
          <div class="row">
            <div class="col-12">
              <!-- <label class="form-label">{{$t('users.inputs.name')}}</label> -->
              <va-input
                id="name-input"
                v-model="userForm.data.name"
                :placeholder="$t('users.inputs.name')"
                :error="userForm.errors.has('name')"
                :error-messages="[$t(userForm.errors.get('name'))]"
                @focus="userForm.errors.clear('name')"
                />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <!-- <label class="form-label">{{$t('users.inputs.email')}}</label> -->
              <va-input
                id="email-input"
                v-model="userForm.data.email"
                :placeholder="$t('users.inputs.email')"
                :error="userForm.errors.has('email')"
                :error-messages="[$t(userForm.errors.get('email'))]"
                @focus="userForm.errors.clear('email')"
                />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <!-- <label class="form-label">{{$t('users.inputs.email')}}</label> -->
              <va-input
                id="email-input"
                v-model="userForm.data.nickname"
                :placeholder="$t('users.inputs.nickname')"
                :error="userForm.errors.has('nickname')"
                :error-messages="[$t(userForm.errors.get('nickname'))]"
                @focus="userForm.errors.clear('nickname')"
                />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <label class="form-label">{{$t('users.inputs.entity')}}</label>
              <multiselect
                id="user-entity-multiselect"
                v-model="userForm.data.entity"
                :options="writableEntities"
                track-by="id"
                label="name"
                select-label=""
                deselect-label="×"
                open-direction="bellow"
                placeholder="---"
                :allow-empty="false"
                :multiple="false"
                :searchable="true"
                :disabled="!hasUsersPermission"
                @input="userForm.errors.clear('entity')"
                >
                <span slot="noResult">{{$t('patients.noResults')}}</span>
              </multiselect>
              <div class="text-danger" v-if="userForm.errors.has('entity')">
                <small>
                  {{$t(userForm.errors.get('entity'))}}
                </small>
              </div>
            </div>
          </div>

          <!-- Edit User Profile -->

          <div v-if="!isUpdate && userForm.data.entity && userForm.data.entity.id === 2" class="mb-3">
            <div class="d-flex px-5 justify-content-between mb-3">
              <va-radio-button
                v-if="showSeniorManagerOption"
                id="radio-rm"
                v-model="profileForm.data.profile"
                :label="$t('users.inputs.profile_senior_manager')"
                option="Senior Manager"
                :disabled="userProfile === null"
                @input="profileForm.errors.clear('profile')"
              />

              <va-radio-button
                v-if="showManagerOption"
                :label="$t('users.inputs.profile_manager')"
                id="radio-am"
                option="Manager"
                v-model="profileForm.data.profile"
                :disabled="userProfile === null"
                @input="profileForm.errors.clear('profile')"
              />

              <va-radio-button
                v-if="showConsultantOption"
                :label="$t('users.inputs.profile_consultant')"
                id="radio-cs"
                option="Consultant"
                v-model="profileForm.data.profile"
                :disabled="userProfile === null"
                @input="profileForm.errors.clear('profile')"
              />

              <va-radio-button
                v-if="showSupportOption"
                :label="$t('users.inputs.profile_support')"
                id="radio-support"
                option="Support"
                v-model="profileForm.data.profile"
                :disabled="userProfile === null"
                @input="profileForm.errors.clear('profile')"
              />
            </div>

            <div v-if="profileForm.errors.has('profile')" class="text-danger mx-3">
              <small>{{ profileForm.errors.get('profile') }}</small>
            </div>

            <div class="row" v-if="showSeniorManager">
              <div class="col-12">
                <label class="form-label">{{$t('entityrequests.senior_manager')}}</label>
                <multiselect
                  v-model="profileForm.data.senior_manager"
                  :options="availableSeniorManagers"
                  track-by="id"
                  label="name"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  placeholder="---"
                  :allow-empty="false"
                  :multiple="false"
                  :searchable="true"
                  @input="profileForm.errors.clear('senior_manager')"
                  >
                  <span slot="noResult">{{$t('patients.noResults')}}</span>
                </multiselect>
                <div class="text-danger" v-if="profileForm.errors.has('senior_manager')">
                  <small>
                    {{$t(profileForm.errors.get('senior_manager'))}}
                  </small>
                </div>
              </div>
            </div>

            <div class="row" v-if="showManager">
              <div class="col-12">
                <label class="form-label">{{$t('entityrequests.manager')}}</label>
                <multiselect
                  v-model="profileForm.data.manager"
                  :options="availableManagers"
                  track-by="id"
                  label="name"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  placeholder="---"
                  :disabled="!profileForm.data.senior_manager"
                  :allow-empty="false"
                  :multiple="false"
                  :searchable="true"
                  @input="profileForm.errors.clear('manager')"
                  >
                  <span slot="noResult">{{$t('patients.noResults')}}</span>
                </multiselect>
                <div class="text-danger" v-if="profileForm.errors.has('manager')">
                  <small>
                    {{$t(profileForm.errors.get('manager'))}}
                  </small>
                </div>
              </div>

            </div>
          </div>

          <div class="row" v-if="!isUpdate">
            <va-checkbox
            class="col-12"
            v-if="!isUpdate"
            :label="$t('users.inputs.email_password')"
            :id="'checkboxPassword'"
            :isCircle="true"
            v-model="sendConfirmationMail"/>
          </div>

          <div v-if="isUpdate || !sendConfirmationMail">
            <div class="row" v-if="isUpdate || !sendConfirmationMail">
              <div class="col-12">
                <label class="form-label">{{$t('users.inputs.password')}}</label>
                <va-input
                  id="user-password"
                  autocomplete="off"
                  :type="passwordInputType"
                  v-model="userForm.data.password"
                  :placeholder="$t('users.inputs.password')"
                  :error="userForm.errors.has('password') || invalidPassword"
                  :error-messages="[$t('users.inputs.invalid_password')]"
                  @focus="userForm.errors.clear('password')"
                >
                  <span slot="append" @click="togglePasswordInputType('passwordInputType')">
                    <va-icon
                      class="clickable"
                      :class="{'i-evollu-password-show': passwordInputType === 'password','i-evollu-password-hide': passwordInputType !== 'password'}"
                    />
                  </span>
                </va-input>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <label class="form-label">{{$t('users.inputs.password_confirmation')}}</label>
                <va-input
                  id="user-password-confirmation"
                  autocomplete="off"
                  :type="passwordConfirmationInputType"
                  v-model="userForm.data.password_confirmation"
                  :placeholder="$t('users.inputs.password_confirmation')"
                  :error="userForm.errors.has('password_confirmation') || nonMatchingPassword"
                  :error-messages="[$t('users.inputs.different_password')]"
                  @focus="userForm.errors.clear('password_confirmation')"
                >
                  <span slot="append" @click="togglePasswordInputType('passwordConfirmationInputType')">
                    <va-icon
                      class="clickable"
                      :class="{'i-evollu-password-show': passwordConfirmationInputType === 'password','i-evollu-password-hide': passwordConfirmationInputType !== 'password'}"
                    />
                  </span>
                </va-input>
              </div>
            </div>

          </div>
        </form>
    </va-modal>
  </section>
</template>
<script>
import Multiselect from 'vue-multiselect'
import Errors from '@/utils/CustomNodeErrors.js'
import ConfirmationModal from '@/components/common/ConfirmationModal'
import { UserService, ProfileService } from '@/api/AuthService'
import { EMAIL_REGEX, PASSWORD_REGEX } from '@/utils/regex'

const GlinttEntityId = 2
const usersInfoType = 100
const writeAccessType = 2

export default {
  components: {
    Multiselect,
    ConfirmationModal
  },
  props: {
    entity: {
      type: Object,
      required: false
    },
    user: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      showModal: false,
      sendConfirmationMail: true,
      passwordInputType: 'password',
      passwordConfirmationInputType: 'password',
      userForm: {
        data: {
          name: '',
          email: '',
          nickname: '',
          entity: null,
          password: '',
          password_confirmation: '',
        },
        errors: new Errors()
      },
      profileForm: {
        data: {
          senior_manager: null,
          manager: null,
          profile: null
        },
        errors: new Errors()
      },
      userProfile: null,
      availableSeniorManagers: [],
      availableManagers: [],
      showSeniorManager: false,
      showManager: false,
      profiles: [
        { id: 2, label: 'project_manager', description: 'Project Manager' },
        { id: 3, label: 'senior_manager', description: 'Senior Manager' },
        { id: 4, label: 'manager', description: 'Manager' },
        { id: 5, label: 'consultant', description: 'Consultant' },
        { id: 6, label: 'support', description: 'Support' }
      ]
    }
  },
  created: function () {
    this.loadUserProfile()
    this.fillForm()
  },
  mounted: function () {
    this.showModal = true
  },
  methods: {
    loadUserProfile: function () {
      ProfileService.get(this.$auth.user().id)
        .then(profile => {
          if (profile === null) {
            this.profileForm.errors.set('profile', this.$t('users.user_profile_is_required_to_set_profile'))
          } else {
            this.userProfile = profile
            if (this.userProfile.profile.type === 'Project Manager' || this.userProfile.profile.type === 'Project Manager Evollu') {
              if (this.userProfile.childrens) this.availableSeniorManagers = this.userProfile.childrens
            } else if (this.userProfile.profile.type === 'Senior Manager') {
              if (this.userProfile.childrens) this.availableManagers = this.userProfile.childrens
            }
          }
        }).catch((errors) => {
          console.log(errors)
        })
    },
    fillForm: function () {
      if (this.user) {
        this.userForm.data = Object.assign(this.userForm.data, this.user, {
          entity: this.writableEntities.find(entity => entity.id === this.user.entity_id) || null
        })
      } else if (this.entity) {
        this.userForm.data.entity = this.writableEntities.find(entity => entity.id === this.entity.id) || null
      }
    },
    submitForm: function () {
      let userFormData = this.getUserFormData()
      if (userFormData) {
        if (this.isUpdate) {
          UserService.update(this.user.id, userFormData)
            .then(user => {
              this.showToast(this.$t('users.users_updated'), this.$store.state.successToastOptions)
              this.$emit('user-updated', { user })
              this.$refs.createOrUpdateUser.cancel()
            })
            .catch(errors => {
              console.log(errors)
              if (errors.hasOwnProperty('response') && errors.response.status === 422) {
                this.userForm.errors.record(errors.response.data.errors, 'users.errors.')
              } else {
                this.showToast(this.$t('users.errors.something_went_wrong'), this.$store.state.successToastOptions)
              }
            })
        } else {
          let profileFormData = null
          if (this.userProfile !== null && userFormData.entity !== null && userFormData.entity === GlinttEntityId) {
            profileFormData = this.getProfileFormData()
          }

          if (userFormData.entity !== GlinttEntityId || (userFormData.entity === GlinttEntityId && profileFormData && this.userProfile !== null)) {
            UserService.store(userFormData)
              .then(user => {
                if (user.entity_id === GlinttEntityId) {
                  UserService.storeProfile(user.id, profileFormData)
                    .catch(errors => {
                      console.log(errors)
                    })
                }
                this.showToast(this.$t('users.users_created'), this.$store.state.successToastOptions)
                this.$emit('user-created', { user })
                this.$refs.createOrUpdateUser.cancel()
              })
              .catch(errors => {
                console.log(errors)
                if (errors.hasOwnProperty('response') && errors.response.status === 422) {
                  this.userForm.errors.record(errors.response.data.errors, 'users.errors.')
                } else {
                  this.showToast(this.$t('users.errors.something_went_wrong'), this.$store.state.successToastOptions)
                }
              })
          }
        }
      }
    },
    getUserFormData: function () {
      let data = JSON.parse(JSON.stringify(this.userForm.data))

      data.entity = data.entity ? data.entity.id : null

      let errors = false

      if (!this.sendConfirmationMail) {
        if (!this.userForm.data.password || this.invalidPassword) {
          this.userForm.errors.set('password', this.$t('users.inputs.invalid_password'))
          errors = true
        }

        if (!this.userForm.data.password_confirmation || this.nonMatchingPassword) {
          this.userForm.errors.set('password_confirmation', this.$t('users.inputs.different_password'))
          errors = true
        }
      }

      if (!this.userForm.data.password.trim()) {
        delete data.password
      }

      if (!this.userForm.data.password_confirmation.trim()) {
        delete data.password_confirmation
      }

      return errors ? null : data
    },
    getProfileFormData: function () {
      let data = {}

      const selectedProfile = this.profiles.find(profile => profile.description === this.profileForm.data.profile) || null
      if (selectedProfile) {
        data.profile = selectedProfile.id
      } else {
        this.profileForm.errors.set('profile', this.$t('users.errors.invalid_profile'))
      }

      if (this.showSeniorManager) {
        if (this.profileForm.data.senior_manager) {
          data.senior_manager_id = this.profileForm.data.senior_manager.id
        } else {
          this.profileForm.errors.set('senior_manager', this.$t('users.errors.invalid_senior_manager'))
        }
      }

      if (this.showManager) {
        if (this.profileForm.data.manager) {
          data.manager_id = this.profileForm.data.manager.id
        } else {
          this.profileForm.errors.set('manager', this.$t('users.errors.invalid_manager'))
        }
      }

      return this.profileForm.errors.any() ? null : data
    },
    togglePasswordInputType: function (field) {
      this[field] = this[field] === 'password' ? 'text' : 'password'
    },
    onCancel: function () {
      this.showModal = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    },
    loadChildsForUser (user) {
      this.$http({
        url: this.$store.state.evollead_server + '/users/' + user.id + '/profile',
        params: { childs: true }
      }).then(response => {
        this.availableManagers = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    diffBetweenProfiles (profile) {
      let profiles = ['Project Manager', 'Senior Manager', 'Manager', 'Consultant']
      let userProfile = this.userProfile.profile.type
      return profiles.indexOf(profile) - profiles.indexOf(userProfile)
    },
  },
  computed: {
    hasUsersPermission: function () {
      if (this.$auth.user().services && this.$auth.user().services.length) {
        let configurationsService = this.$auth.user().services.find(service => service.id === 6)
        return configurationsService ? configurationsService.user_permissions.some(permission => permission.access_type >= 2 && permission.info_type === 100) : false
      }
      return false
    },
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    },
    writableEntities: function () {
      if (this.authService) {
        let permissions = this.authService.user_permissions.filter(p => p.info_type === usersInfoType && p.access_type >= writeAccessType)
        if (permissions.some(p => p.entity_id === null)) {
          return [...this.authService.entities]
        } else {
          return this.authService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
        }
      }
      return []
    },
    isUpdate: function () {
      return !!this.user
    },
    invalidEmail: function () {
      if (this.userForm.data.email) {
        return !this.userForm.data.email.match(EMAIL_REGEX)
      }
      return true
    },
    invalidPassword: function () {
      if (this.userForm.data.password) {
        return !this.userForm.data.password.match(PASSWORD_REGEX)
      }
      return false
    },
    nonMatchingPassword: function () {
      if (this.userForm.data.password && !this.invalidPassword && this.userForm.data.password_confirmation) {
        return this.userForm.data.password !== this.userForm.data.password_confirmation
      }
      return false
    },
    canSetUserProfile: function () {
      return this.userForm.data.entity && this.userForm.data.entity.id === 2 && this.userProfile !== null
    },
    showSeniorManagerOption: function () {
      return this.canSetUserProfile && (this.diffBetweenProfiles('Senior Manager') > 0)
    },
    showSupportOption: function () {
      return this.canSetUserProfile && (this.diffBetweenProfiles('Senior Manager') > 0)
    },
    showManagerOption: function () {
      return this.canSetUserProfile && (this.diffBetweenProfiles('Manager') > 0)
    },
    showConsultantOption: function () {
      return this.canSetUserProfile && (this.diffBetweenProfiles('Consultant') > 0)
    }
  },
  watch: {
    'userForm.data.entity': function (value) {
      if (value && value.id !== 2) {
        this.profileForm.data.manager = null
        this.profileForm.data.senior_manager = null
        this.profileForm.data.profile = null
      }
    },
    'sendConfirmationMail': function (value) {
      if (!value) {
        this.userForm.data.password = ''
        this.userForm.data.password_confirmation = ''
      }
    },
    'profileForm.data.profile': {
      handler: function (profile) {
        let profiles = ['Project Manager', 'Senior Manager', 'Manager', 'Consultant']
        let chosenIndex = profiles.indexOf(profile)
        this.showSeniorManager = false
        this.showManager = false
        if (profile === 'Senior Manager' && this.profileForm.data.senior_manager) {
          this.profileForm.data.senior_manager = null
        }
        if (profile === 'Manager' && this.profileForm.data.manager) {
          this.profileForm.data.manager = null
        }
        if (profile === 'Consultant' && this.profileForm.data.senior_manager) {
          this.loadChildsForUser(this.profileForm.data.senior_manager)
        }
        while (chosenIndex > 0) {
          if (profiles[chosenIndex] === 'Manager' && this.diffBetweenProfiles(profiles[chosenIndex]) >= 2) {
            this.showSeniorManager = true
          }
          if (profiles[chosenIndex] === 'Consultant' && this.diffBetweenProfiles(profiles[chosenIndex]) >= 2) {
            this.showManager = true
          }
          chosenIndex = chosenIndex - 1
        }
        this.profileForm.errors.clear()
      },
      deep: true
    },
    'profileForm.data.senior_manager': function (seniorManager) {
      this.profileForm.data.manager = null
      if (seniorManager) {
        this.loadChildsForUser(seniorManager)
      }
    }
  }
}
</script>
